<template>
  <v-autocomplete
      v-model="company"
      :items="companies"
      :loading="isLoading"
      item-text="name"
      item-value="inn"
      :clearable="clearable"
      :placeholder="placeholder"
      :label="label"
      :dense="dense"
      :no-filter="true"
      :error="error"
      :allow-overflow="allowOverflow"
      @update:search-input="onSearch"
      @change="onChange"
      outlined
  >
    <template v-slot:no-data>
      <v-list-item> По данному фильтру нет данных </v-list-item>
    </template>

    <template v-slot:selection="{ item }">
      <v-list-item-content color="success" style="display: contents">
        <v-list-item-title>{{ item.name }}</v-list-item-title>
        <v-list-item-subtitle>{{ item.inn }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>

    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title v-html="item.name"></v-list-item-title>
        <v-list-item-subtitle v-html="item.inn"></v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>

<script>
import _ from "underscore";
import Company from "@/domain/Company";
import CompanyService from "@/services/company.service";

export default {
  name: "SelectCompany",
  props: {
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    allowOverflow: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      company: null,
      companies: [],
      isLoading: false,
      filterTimerId: null,

      lastSearch: "",
    };
  },
  methods: {
    onChange() {
      let value = null;
      if (this.company) {
        value = _.find(this.companies, (c) => {
          return c.inn === this.company;
        });
      }
      this.$emit("input", value);
      this.$emit("change", value);
    },
    onSearch: _.debounce(function (search) {
      if (search && !this.company && this.lastSearch !== search)
        this.filter(search);
    }, 1000),

    filter(search) {
      const query = search;
      CompanyService.search({
        query: query,
        limit: 10,
        soliq: true,
      })
          .then((response) => {
            this.lastSearch = query;
            this.companies = _.map(response.data, (c) => {
              let company = new Company();
              company.inn = c.Inn;
              company.name = c.Name;

              return company;
            });
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
  },
  created() {
    this.filter("");
  },
};
</script>